// mini-binary-switch/lib/components/BinarySwitch.tsx
export const BINARY_SWITCH = 'binarySwitch';

// mini-mail-list-filter/lib/component/MailListFilterBUtton.tsx
export const FILTER = 'filter';
export type MailHeaderElementToFocus = 'binarySwitch' | 'filter';
